// 管理后台
import { getLocalOrRemoteUserInfo } from '@/utils/FPUser'
import { checkoutAdmin } from '@/utils/RoutesBeforeUtils'
import { ElMessage } from 'element-plus'

// const checkAdminAuth = async (to, from, next) => {
//     try {
//         const userInfo = await getLocalOrRemoteUserInfo()
//         if (!userInfo || userInfo.email !== 'tanhang.long99@gmail.com') {
//             ElMessage.error('无权限访问管理页面')
//             next('/')
//             return
//         }
//         next()
//     } catch (error) {
//         console.log("admin checkAdminAuth error:", error)
//         ElMessage.error('请先登录')
//         next('/')
//         return
//     }
// }

const AdminRoutes = [
    {
        path: '/admin',
        name: 'AdminLayout',
        component: () => import('@/views/admin/AdminLayout.vue'),
        redirect: '/admin/products/list',
        beforeEnter: checkoutAdmin,
        children: [
            // 产品账号管理
            {
                path: 'products',
                name: 'AdminProducts',
                redirect: '/admin/products/inventory',
                children: [
                    // 补货
                    {
                        path: 'inventory',
                        name: 'AdminInventory',
                        component: () => import('@/views/admin/products/InventoryView.vue'),
                        meta: { title: '账号补货' }
                    },
                    // 产品列表
                    {
                        path: 'list',
                        name: 'AdminProductList',
                        component: () => import('@/views/admin/products/ProductListView.vue'),
                        meta: { title: '账号列表' }
                    },
                    // 验证码列表
                    {
                        path: 'verification',
                        name: 'AdminVerificationList',
                        component: () => import('@/views/admin/products/VerificationListView.vue'),
                        meta: { title: '验证码列表' }
                    }
                ]
            },
            // 订单管理
            {
                path: 'orders',
                name: 'AdminOrders',
                component: () => import('@/views/admin/orders/OrdersView.vue'),
                meta: { title: '订单列表' }
            },
            // 用户权益管理
            {
                path: 'user-rights',
                name: 'AdminUserRights',
                component: () => import('@/views/admin/rights/UserRightsView.vue'),
                meta: { title: '用户权益' }
            },
            {
                path: 'user-fission-info',
                name: 'AdminUserFissionInfo',
                component: () => import('@/views/admin/rights/UserFissionInfoView.vue'),
                meta: { title: '用户裂变信息' }
            },
            {
                path: 'points-records',
                name: 'AdminUserPointRecords',
                component: () => import('@/views/admin/rights/UserPointRecordsView.vue'),
                meta: { title: '用户权益' }
            },
            {
                path: "invite-info",
                name: "AdminInviteInfo",
                component: () => import('@/views/admin/rights/UserInviteInfoView.vue'),
            },
            // 用户管理
            {
                path: 'users',
                name: 'AdminUsers',
                component: () => import('@/views/admin/users/UserListView.vue'),
                meta: { title: '用户管理' }
            }
        ]
    }
]
export default AdminRoutes